import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function Benefits() {
  const benefits = [{
    emoji: '📖',
    text: <>
          Pasarás de leer nombres abstractos a{' '}
          <strong data-id="element-17">VER los lugares reales</strong> donde ocurrió cada
          acontecimiento bíblico
        </>
  }, {
    emoji: '🗺️',
    text: <>
          Entenderás <strong data-id="element-18">POR QUÉ</strong> los eventos ocurrieron donde
          ocurrieron
        </>
  }, {
    emoji: '🎓',
    text: <>
          Alcanzarás una{' '}
          <span className="underline decoration-green-500 decoration-2 underline-offset-2" data-id="element-19">
            profundidad de estudio que pocos tienen
          </span>
          . Tus devocionales, clases y sermones tendrán un nivel de detalle que{' '}
          <strong data-id="element-20">impactará a quienes te escuchen</strong>.
        </>
  }, {
    emoji: '⚡',
    text: <>
          Tendrás un{' '}
          <strong data-id="element-21">recurso de consulta inmediata para toda la vida</strong>. Cada
          vez que leas un pasaje y quieras saber{' '}
          <span className="underline decoration-gold decoration-2 underline-offset-2" data-id="element-22">
            DÓNDE y CÓMO
          </span>{' '}
          se veía ese lugar, abrirás tu Biblia Visual y lo tendrás al instante
        </>
  }];
  return <section className="py-12 bg-cream" data-id="element-23">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-24">
        <FadeIn data-id="element-25">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-center text-navy-900 mb-7" data-id="element-26">
            ¿Qué Lograrás Con Este Recurso?
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-27">
          {benefits.map((benefit, index) => <FadeIn key={index} delay={index * 0.08} className="h-full" data-id="element-28">
              <div className="h-full flex flex-col p-5 rounded-xl bg-white border-l-4 border-green-600 shadow-md" data-id="element-29">
                <div className="text-3xl mb-2" data-id="element-30">{benefit.emoji}</div>
                <p className="text-base text-gray-800 leading-relaxed font-medium" data-id="element-31">
                  {benefit.text}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}